import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ description, lang, meta, title, imgUrl }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            shareImageUrl
            siteUrl
            siteName
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const metaImageUrl = imgUrl || site.siteMetadata.shareImageUrl
  const metaSiteUrl = site.siteMetadata.siteUrl
  const metaSiteName = site.siteMetadata.siteName    

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:url`,
          content: `${metaSiteUrl}`,
        },
        {
          property: `og:site_name`,
          content: `${metaSiteName}`,
        },
        {
          property: `og:image`,
          content: `${metaImageUrl}`,
        },
        {
          property: `og:image:width`,
          content: `1000`,
        },
        {
          property: `og:image:height`,
          content: `500`,
        },
        {
          property: `og:image:type`,
          content: `image/jpeg`,
        },
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          name: `twitter:image`,
          content: `${metaImageUrl}`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
  imgUrl: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  imgUrl: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
